import { render, staticRenderFns } from "./CustomerObjects.vue?vue&type=template&id=6ebaef97&"
import script from "./CustomerObjects.vue?vue&type=script&lang=js&"
export * from "./CustomerObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports